import { Identifiable, Zone } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isProjectsTransferRequestFailure(destination: Identifiable<Zone>) {
      const state = getState().find(
        (item) => item.destination.uuid === destination.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isProjectsTransferRequestPending(destination: Identifiable<Zone>) {
      const state = getState().find(
        (item) => item.destination.uuid === destination.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isProjectsTransferRequestSuccess(destination: Identifiable<Zone>) {
      const state = getState().find(
        (item) => item.destination.uuid === destination.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
